import { Role } from '@/models/Role';

const programStateStatus = [
  { text: 'En saisie', value: 'data_processing', color: '#000' },
  { text: 'À contrôler', value: 'to_control', color: '#0000ff' },
  { text: 'Diffusé', value: 'diffused', color: '#387644' },
  { text: 'Vendu', value: 'sold', color: '#a64d7b' },
  { text: 'Dev en cours', value: 'in_dev', color: '#D471B3' },
  { text: 'Attente retour Dev. vendeur', value: 'waiting_dev_promoter', color: '#7ED7C8' },
  { text: 'Retiré', value: 'withdraw', color: '#ff002e' }
]

function getStatusItems(currentStatus: string, roles: Role[]) {
  if (roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MANAGER')) {
    return programStateStatus;

  } else {
    return [programStateStatus[0], programStateStatus[1]];
  }
}

function formatProgramStateStatus(status: string) {
  const out = programStateStatus.find(s => s.value == status);
  return out ? out.text : status;
}

function getProgramStateStatusColor(status: string) {
  const out = programStateStatus.find(s => s.value == status);
  return out ? out.color : status;
}

export {
  formatProgramStateStatus,
  getProgramStateStatusColor,
  getStatusItems
}